module.exports = __webpack_public_path__ + "static/scale-model-of-chase,-albon,-house-in-athens-georgia-3faa9733541d219dd8c03aec36186a13.png";